import React, { useState, useEffect, useRef } from 'react'

import { useDispatch, useSelector, shallowEqual } from 'react-redux'


import { Table, Tooltip,Tag,Form, Input, Button, Space,Modal,Descriptions,
  Statistic, Col,Popconfirm,Collapse,Select,DatePicker, Progress,
  TimePicker,Checkbox, message} from 'antd';
import {   
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    UserOutlined,
    VideoCameraOutlined,
    UploadOutlined, 
    DeploymentUnitOutlined,
    SearchOutlined,
    EditOutlined,
    PlusOutlined,
    CalculatorOutlined
} from '@ant-design/icons';

import './styles.scss'

import moment from 'moment'
import {getData,editItem,addItem,deleteItem} from '../../../Redux/actions/crudActions'
import {addProductIngredients,editProductIngredients,deleteProductIngredients} from '../../../Redux/actions/productActions'


import {errorParser} from '../../../utils/helpers'

import CreateForm from '../../Generic/CreateForm'

import {numberWithCommas} from '../../../utils/helpers' 
import ImageChecker from '../../Generic/ImageChecker';
import ProductLiveChangePrice from '../ProductLiveChangePrice'


const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

const Index = ({onModalClose,categoryFilters}) => { 
    
    const dispatch = useDispatch()    

    const {user,crudData,crudDataCount } = useSelector(
      state => ({
        user: state.auth.user,
        crudData: state.products.data,
        crudDataCount: state.products.dataCount,
      }),
      shallowEqual
    )

    const [isModalVisible, setIsModalVisible] = useState(false); 
    const [currentOrder, setCurrentOrder] = useState(''); 
    const [progress, setProgress] = useState(0)

    const [loading, setLoading] = useState(false)
    const [item, setItem] = useState(false)

    const [formSubmitClick, setFormSubmitClick] = useState(false)
    const [modalWidth, setmodalWidth] = useState('80%')

    useEffect(() => {
      if(isModalVisible){
        setLoading(true)
      }
    },[isModalVisible]);
    
    useEffect(() => {
      console.log(crudData)
    },[crudData]);

    useEffect(() => {
      if(progress >= crudDataCount){
        setLoading(false)
        message.success('new prices done calculating')
      
      }
    },[progress]);

    
    var columns = [

      {      
        title: 'Category', 
        dataIndex: 'category_name',
        key: 'category_name',         
        sorter: (a, b) => a.category_name.localeCompare(b.category_name),  
        fixed: 'left',
         
        // filters:categoryFilters,
        // onFilter: (value, record) => value.includes(record.category_name),   
      },  
      {
        title: 'Image',
        width:'5em',
        render: (text, record, index) =>{ 
          return (
            <ImageChecker                 
              url={`${process.env.REACT_APP_AWS_S3}${record.id}.png`}
              success={      
                <img src={`${process.env.REACT_APP_AWS_S3}${record.id}.png`} alt="image"   className={"prodimage"}/>                           
              }
              fail= {   <img src={`${process.env.REACT_APP_AWS_S3}logo.jpg`} alt="image"   className={"prodimage"}/>     }
            />      
          );                                      
        }
      },

      {      
        title: 'Name', 
        dataIndex: 'name',
        key: 'name',         
        sorter: (a, b) => a.name.localeCompare(b.name),  

        search: 'name',     
          
        render: (text, record, index) =>{ 
          return (<div className='name'>{text}</div>); 
        }
 
      },

      
      {
        title: 'Current Price',
  
        render: (text, record, index) =>{ 
          if(record){
            if(record.regionalization == 'local'){
              return (<div className='oneline'>{`₱ ${numberWithCommas(parseFloat(record.cost_peso).toFixed(2))}`}</div>); 
            }
            if(record.regionalization == 'international' && user.role == 'admin'){
              return (<div className='oneline'>{`¥ ${numberWithCommas(parseFloat(record.cost_rmb).toFixed(2))}`}</div>); 
            }
          }
         
                                             
        }
      },
      {
        title: 'New Price',
    
        render: (text, record, index) =>{ 
          if(record && index <= progress){
           
            return(
              <ProductLiveChangePrice currentItem={record} done={(e)=>{setProgress(progress+1)}} />
            )
          }else{
            return(<Tag color="yellow">pending</Tag>)
          }
         
                                             
        }
      },
 

     
    ]








    


    
    const footer = () =>{
      return(
        <div>

          <Button type="default" loading={loading} onClick={()=>{closeModal()}} >
            Close
          </Button>      
          
        </div>
      )
     
    }
    

    const closeModal = (action) =>{
      if(!loading){   
        setIsModalVisible(false);    
        setProgress(0)

        if(progress >= crudDataCount){
          onModalClose('reset');
        }else{
          onModalClose(action);
        }
 
      }else{
        message.warning('please wait for calculations to finish')
      }
    }

    return(       
      <>
      {crudDataCount > 0  && (user.role =='admin' ) ?
      <div className={""}>
        <Button  type="default"  icon={<CalculatorOutlined />} onClick={()=>{setIsModalVisible(true); setLoading(false)}} >{`Recalculate Price`}</Button>  
        
      </div>
      :null}



      {isModalVisible?  
        <Modal title={'Recalculate Product Prices'}  className="productRecalculatePrice-content"  visible={isModalVisible} footer={footer()} onCancel={()=>{closeModal()}}  >

            <div className='progresspart'>
              <Progress percent={parseFloat(progress/crudDataCount)*100}  className='bar' strokeColor="#52c41a"  showInfo={false} />
              <h3>
                {progress}/{crudDataCount}
              </h3>
            </div>
            <Table columns={columns} dataSource={crudData} pagination={false} />
     
        </Modal>
        :null}
      </>
    )
}
  
export default Index
  